// views/LogoutPage.js
import React from 'react';
import { useOktaAuth } from '@okta/okta-react';

const LogoutPage = () => {
  const { oktaAuth } = useOktaAuth();

  const handleLogin = () => {
    oktaAuth.signInWithRedirect();
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-2xl font-bold mb-4">You've been logged out.</h1>
      <button
        onClick={handleLogin}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        Login Again
      </button>
    </div>
  );
};

export default LogoutPage;
